module.exports = __webpack_public_path__ + "static/media/qicon.3ba5f427.png";